<template lang="pug">
  .component-plan-reservation-rates
    template(v-if="Object.keys(planRates).length")
      ul.tabs(id="tabs", :data-deep-link='false', :data-update-history='false', :data-deep-link-smudge='false', :data-deep-link-smudge-delay='500' data-tabs='')
        li.tabs-title(v-for="(tab,key, index) in bookingModes", :class="{'is-active': index === 0}")
          a(:href="'#'+tab" :aria-selected='index === 0') {{tab}} ({{getTotal(tab)}})
      .tabs-content(data-tabs-content='tabs',)
        .tabs-panel.is-active(v-for="(tab,key, index) in bookingModes", :id="tab")
          CreatePlanReservationRates(:booking-mode="tab", :plan-id="$route.params.id", @added="loadModes")
          template(v-if="hasPlanForBm(tab)", v-for="(planRates, key) in planRates.items[tab]", :id="key")
            plan-reservation-rate(:item="planRates", type="listing")
</template>
<script type="text/babel">

import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
import PlanReservationRate from "../PlanReservationRate.vue";
import collect from "collect.js";
import TabHeaders from 'components/structure/foundation/TabHeaders'
import TabContent from 'components/structure/foundation/TabContent'
import CreatePlanReservationRates from "./CreatePlanReservationRates.vue";
import {EventBus} from "../../../eventBus";


export default {
  name: "PlanReservationRates",
  components: {CreatePlanReservationRates, TabContent, TabHeaders, PlanReservationRate},
  data() {
    return {
      planRates: [],
      bookingModes: []
    }
  },
  mounted() {
  },
  created() {
    EventBus.$on('reload-list', () => {
      this.loadModes()
    })
    this.loadModes()
  },
  destroyed() {
    EventBus.$off('reload-list')
  },
  methods: {
    hasPlanForBm(bm) {
      return this.planRates.items !== undefined && Object.keys(this.planRates.items).includes(bm)
    },
    getTotal(bm) {
      if (this.hasPlanForBm(bm)) {
        return this.planRates.items[bm].length
      }
      return 0
    },
    loadModes() {
      this.bookingModes = []
      this.planRates = []
      KeplerBackofficeSdk.reservations.list().modes((data) => {
        Object.keys(data).map((key) => {
          data[key] = key
        });

        this.bookingModes = data;
        this.loadRates()
      })
    },
    loadRates() {
      KeplerBackofficeSdk.plans.select(this.$route.params.id).rates((data) => {
        this.planRates = collect(data).groupBy('booking_mode')
        // START 🤮🤮🤮🤮🤮
        this.$nextTick(() => {
          $(this.$el).find('#tabs').foundation()
        })
        // END 🤮🤮🤮🤮🤮
      })
    }
  },
  computed: {}
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PlanReservationRates.vue?d17ea4b8